export default __webpack_public_path__ + "static/media/announcement_3@2x.3b4f770f.png";